// Native disclosures and cart links keep working before enhancement and without JS.
function setupHeader(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const disclosures = [...root.querySelectorAll('[data-ws-disclosure]')];
  disclosures.forEach(item => item.addEventListener('toggle', () => {
    if (!item.open) return;
    disclosures.forEach(other => { if (other !== item) other.open = false; });
    if (item.classList.contains('ws-header-search')) item.querySelector('input[type=search]')?.focus();
  }));
  root.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = disclosures.find(item => item.open);
    if (active) { active.open = false; active.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', event => {
    if (!root.contains(event.target)) disclosures.forEach(item => { item.open = false; });
  });
  root.querySelector('[data-ws-cart]')?.addEventListener('click', event => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { event.preventDefault(); drawer.open(); }
  });
}
function setup() {
  document.querySelectorAll('[data-ws-header]').forEach(setupHeader);
  const mobile = matchMedia('(max-width: 767px)');
  document.querySelectorAll('[data-ws-footer-details]').forEach(item => {
    if (item.dataset.ready) return;
    item.dataset.ready = 'true';
    const adapt = () => { item.open = !mobile.matches; };
    adapt();
    mobile.addEventListener('change', adapt);
  });
}
setup();
document.addEventListener('shopify:section:load', setup);
